import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type * as fhirTypes from "fhir/r4";

interface ObservationsResponse {
  observationsWithPredefinedCodes: {
    observationCode: fhirTypes.CodeableConcept;
    observationResource: fhirTypes.Observation | null;
  }[];
  nonPredefinedCodeObservations: fhirTypes.Observation[];
}

interface ObservationsParams {
  patientId?: string;
  encounterId?: string;
}

export const useObservations = ({
  patientId,
  encounterId,
}: ObservationsParams) => {
  return useApi<ObservationsResponse, ObservationsResponse>({
    queryOptions: {
      enabled: !!patientId && !!encounterId,
      queryFn: async () => {
        const response = await axiosInstance.get<ObservationsResponse>(
          "/charting/objective/observations",
          {
            params: {
              patientId,
              encounterId,
            },
          },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.Observation.DEFAULT({
        patientId,
        encounterId,
      }),
    },
  });
};
